import { useMemo } from 'react';
import { useTable, usePagination, useGlobalFilter } from 'react-table';

export const useDataTable = ({ 
  columns, 
  data, 
  initialPageSize = 5, 
  initialPageIndex = 0 
}) => {
  const memoizedColumns = useMemo(() => columns, [columns]);
  const memoizedData = useMemo(() => data, [data]);

  const tableInstance = useTable(
    {
      columns: memoizedColumns,
      data: memoizedData,
      initialState: { 
        pageIndex: initialPageIndex, 
        pageSize: initialPageSize 
      }
    },
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    state: { pageIndex, pageSize, globalFilter }
  } = tableInstance;

  return {
    // Props de la tabla
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    
    // Controles de paginación
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    
    // Búsqueda global
    setGlobalFilter,
    
    // Estado actual
    pageIndex,
    pageSize,
    globalFilter,
    
    // Instancia completa por si se necesita
    tableInstance
  };
};
